module.exports = __webpack_public_path__ + "static/media/Niveau_elN0_4_792388.24b8dcf0.png";